import { CYPRESS_COOKIE_NAME } from '@clef/shared/utils';
// https://stackoverflow.com/questions/5639346/what-is-the-shortest-function-for-reading-a-cookie-by-name-in-javascript
export const getCookieValue = (name: string): string | undefined =>
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop();
export const isCypressEnv = () => getCookieValue(CYPRESS_COOKIE_NAME) === 'true';
export const isJestEnv = process.env.NODE_ENV === 'test';
export const isTestEnv = () => isJestEnv || isCypressEnv();
